"use client";

import { c as _c } from "react/compiler-runtime";
import { LogotypeIcon } from "#/components/atoms/icon-logotype";
import { env } from "#/utilities/env";
import * as AccessibleIcon from "@radix-ui/react-accessible-icon";
import { useIntersectionObserver } from "@react-hookz/web";
import { Link } from "@repo/components/atoms/link";
import { cn } from "@repo/lib";
import { type RefObject, useRef } from "react";
import type { Usable } from "react";
import type { ResolvedIntlConfig } from "react-intl";
import { useGetIntl } from "@repo/i18n/intl/client";
export function Logo(t0) {
  const $ = _c(27);
  const {
    blend,
    className,
    dictionaryPromise,
    hidden,
    lang
  } = t0;
  const rootRef = useRef(null);
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      threshold: [0, 0.5]
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const rootIntersection = useIntersectionObserver(rootRef as RefObject<HTMLDivElement>, t2);
  const intersecting = (rootIntersection?.intersectionRatio ?? 0) > 0 || (rootIntersection?.boundingClientRect?.top ?? 0) < 0;
  const position = intersecting ? "absolute" : "fixed";
  const t3 = blend && "mix-blend-difference";
  let t4;
  if ($[4] !== className || $[5] !== hidden || $[6] !== t3) {
    t4 = cn("pointer-events-none relative inset-0 z-50 grid fill-foreground", t3, className, {
      hidden
    });
    $[4] = className;
    $[5] = hidden;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== position) {
    t5 = {
      position
    };
    $[8] = position;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== className) {
    t6 = cn("pointer-events-auto focus-visible:scale-110 hover:scale-110 hover:**:scale-none transition-all", className);
    $[10] = className;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = `/${lang}`;
  let t8;
  if ($[12] !== intl) {
    t8 = intl.formatMessage({
      id: "yVFeBl",
      defaultMessage: "{siteName} logotype",
      description: "Accessible label for the site logo"
    }, {
      siteName: env.NEXT_PUBLIC_SITE_NAME
    });
    $[12] = intl;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LogotypeIcon className={cn("h-8 transition duration-300 ease-in-out sm:h-10 drop-shadow-xs")} />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8) {
    t10 = <AccessibleIcon.Root label={t8}>{t9}</AccessibleIcon.Root>;
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t6 || $[19] !== t7) {
    t11 = <Link className={t6} href={t7}>{t10}</Link>;
    $[17] = t10;
    $[18] = t6;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t5) {
    t12 = <div className="bottom-12 grid w-full justify-items-center justify-self-center" ref={rootRef} style={t5}>{t11}</div>;
    $[21] = t11;
    $[22] = t5;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t4) {
    t13 = <div className={t4} ref={rootRef}>{t12}</div>;
    $[24] = t12;
    $[25] = t4;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}